import React, {useState} from 'react';
import { useTranslation } from 'react-i18next'
import {closestCenter, DndContext, PointerSensor, useSensor} from '@dnd-kit/core';
import {rectSortingStrategy, SortableContext, arrayMove, useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities'
import { FormControl, FormCheck, Button } from 'react-bootstrap'; 
import EmailItem from './EmailItem';

const SignersCategory = (props) =>{
    const { t } = useTranslation();

    const [signers, setSigners] = useState([]);
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [forceOrder, setForceOrder] = useState(false);
    const [duedate, setDuedate] = useState("");
    const [duedateMax, setDuedateMax] = useState("");
    const [duedateMin, setDuedateMin] = useState("");
    const [reminder, setReminder] = useState("");
    const [addCategoryDisabled, setAddCategoryDisabled] = useState(false);

    const categoryId = props.id;
    const handleDeleteCategory = props.handleDeleteCategory;
    const signersChangedCB = props.signersChangedCB;
    const forceSignOrderChangedCB = props.forceSignOrderChangedCB;
    const dueDateChangedCB = props.dueDateChangedCB;
    const reminderDateChangedCB = props.reminderDateChangedCB;
    const addSignerCategoryCB = props.addSignerCategoryCB;
    const disableDelete = props.disableDelete;
    const disableDates = props.disableDates;
    const getSignersCategoriesCB = props.getSignersCategoriesCB;
    const getDueDateMaxCB = props.getDueDateMaxCB
    const categoryIndex = props.index+1;

    const sensors = [useSensor(PointerSensor)];

    const DAY_IN_MS  = (1000*60*60*24)
    const REMINDER_DATE_DEFAULT_VALUE_IN_MS = (process.env.REACT_APP_CATEGORY_REMINDDATE_BEFORE_DUEDATE*1000*60*60*24)

    const handleKeyDown = event => {
        if (["Enter", "Tab", ","].includes(event.key)) {
        event.preventDefault();
        var value = email.trim();
               
        if (value && isValid(value)) {
            updateSigners([...signers, {email:value}])
            setEmail("")
            setTimeout(() => setAddCategoryDisabled(false), 100);
        }
    }};   
    
    const handleBlur = event => {
        event.preventDefault();
        var value = email.trim();
               
        if (value && isValid(value)) {
            updateSigners([...signers, {email:value}])
            setEmail("")
            setTimeout(() => setAddCategoryDisabled(false), 100);
    }};  
      
    const handleChange = event => {
        setEmail(event.target.value)
        setEmailError("")
        if(event.target.value) {
            setAddCategoryDisabled(true);
        } else {
            setAddCategoryDisabled(false);  
        }
    }; 
 
    const handleDeleteEmail = item => {
        console.log("handleDeleteEmail called")
        updateSigners(signers.filter(current => current.email !== item.email))
         };


    function isValid(email) {
        let error = null;
        if (isInList(email)) {
            error = email + t("has already been added.");
        }
        if (!isEmail(email)) {
            error = email + t("is not a valid email address.");
        }
        if (error) {
            setEmailError(error);
            return false;
        }
        return true;
    }

    const handlePaste = event => {
        event.preventDefault();

        var paste = event.clipboardData.getData("text");
        console.log("Paste",paste)
        //eslint-disable-next-line
        var emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);
        console.log("Emails",emails)
        if (emails) {
        var toBeAdded = emails.filter(email => !isInList(email));
        toBeAdded = toBeAdded.map(emailAddress => {
            return {email:emailAddress};
        })
        console.log("toBeAdded",toBeAdded)

        updateSigners([...signers, ...toBeAdded])
        }
    };  

    function isInList(email) {
        return signers.map(item => item.email.toLowerCase()).includes(email.toLowerCase());
    }

    function isEmail(email) {
        // eslint-disable-next-line  
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
    }

    function updateSignersDragEnd(event) {
        const {active, over} = event;
        
        var oldIndex = 0;
        signers.map((item, index) => { 
            if(item.email === active.id) {
                oldIndex = index;
            }
            return item;
            });
        var newIndex = 0
        signers.map((item, index) => {
            if(item.email === over.id) {
                newIndex = index;
            }
            return item;
        });
        return arrayMove(signers, oldIndex, newIndex)
    }

    function handleDragEndEmailItem(event) {
        const {active, over} = event;
        
        if(active === null || over === null) {
            return;
        }

        if (active.id !== over.id) {
            updateSigners(updateSignersDragEnd(event));
        }
      }

    function addSignerCategory() {
        addSignerCategoryCB(categoryId);
    }

    function forceOrderChanged() {
        console.log("forceOrderChanged", forceOrder);
        setForceOrder(!forceOrder);
        forceSignOrderChangedCB(categoryId, !forceOrder);
    }

    const {
        setNodeRef,
        attributes,
        listeners,
        transition,
        transform
    } = useSortable({id:categoryId})

    const style = {
        transition,
        transform: CSS.Transform.toString(transform)
    }

    function updateSigners(newSigners) {
        var signersCategory = getSignersCategoriesCB();

        // check duplicates with other categories
        var duplicateEmails = [];
        newSigners.map(newSigner => {
            signersCategory.map(category => {
                console.log("category", category)
                console.log("category.signers", category.signers)
                if(category.id !== categoryId) { // ei verrata itseensä
                    category.signers.map(signer => {
                        console.log("VERRATAAN: ", signer.email, newSigner.email)
                        if(signer.email.toLowerCase() === newSigner.email.toLowerCase()) {
                            // duplicate found
                            duplicateEmails.push(newSigner.email); 
                            console.log("DUPLICATE EMAIL", newSigner.email);
                        }
                        return null; // removes warning
                    })
                }
                return null; // removes warning
            })
            return null; // removes warning
        });

        var addSigners = newSigners.filter(signer => {
            return duplicateEmails.findIndex(email => email.toLowerCase() === signer.email.toLowerCase()) === -1;
        })

        setSigners(addSigners);
        console.log("updateSigners: ", addSigners);
        signersChangedCB(categoryId, addSigners);

        if(duplicateEmails.length > 0) {
            // duplicate email found
            var errorText = "";
            duplicateEmails.map(email => {
                errorText =  errorText+ " " +email;
                return null; // removes warning
            })
            setEmailError(errorText+ t("has already been added."));
        }
    }

    function todayString() {
        var dateString = new Date().toISOString().split('T')[0];
        return dateString;
    }

    function setDueDateMaxDate() {
        var signersCategory = getSignersCategoriesCB(); 
        var myCategoryIndex = signersCategory.findIndex(category => category.id === categoryId);

        for(var i=myCategoryIndex+1;i < signersCategory.length;i++) {
            if(signersCategory[i].dueDate !== "") {
                setDuedateMax(new Date(new Date(signersCategory[i].dueDate).getTime()-DAY_IN_MS).toISOString().split('T')[0]);
                return;
            }
        }
        return setDuedateMax(getDueDateMaxCB());
    }

    function setDueDateMinDate() {
        var signersCategory = getSignersCategoriesCB(); 
        var myCategoryIndex = signersCategory.findIndex(category => category.id === categoryId);

        for(var i=myCategoryIndex-1;i >= 0;i--) {
            if(signersCategory[i].dueDate !== "") {
                setDuedateMin(new Date(new Date(signersCategory[i].dueDate).getTime()+DAY_IN_MS).toISOString().split('T')[0]);
                return;
            }
        }
        return setDuedateMin(todayString());
    }

    function setDueDateRanges() {
        setDueDateMinDate();
        setDueDateMaxDate();
    }

    function checkdueDate(newDate) {
        console.log("new date", newDate)
        if(newDate === "") {
            return;
        }
        var newDueDate = new Date(newDate);
        var todayDate = new Date();

        var newReminderDate = new Date(newDueDate.getTime() - REMINDER_DATE_DEFAULT_VALUE_IN_MS);
        // update remider date
        if(todayDate > newReminderDate) {
            newReminderDate = todayDate;
        }
        var dateString = newReminderDate.toISOString().split('T')[0];
        reminderDateChangedCB(categoryId, dateString);
        setReminder(dateString);
        document.getElementById("categoryReminder"+categoryId).value = dateString; // ei näemmä päivity näyttöön ilman tätä
    }

    function changeHandler(event){

        switch(event.target.name) {
            case "duedate":
                checkdueDate(event.target.value);
                dueDateChangedCB(categoryId, event.target.value);
                setDuedate(event.target.value);
                break;
            case "reminder":
                reminderDateChangedCB(categoryId, event.target.value);
                setReminder(event.target.value);
                break;
            default: 
        }
    }

    function clearDates() {
        if(duedate !== "") {
            setDuedate("");
            setDuedateMin("");
            setDuedateMax("");

        }
        if(reminder !== "") {
            setReminder("");
        }
        return null;
    }

    return (
        <div className={"category-tag"}>
            
            {
                disableDelete === false? 
                    (
                        <button
                        type="button"
                        className="btn-close float-sm-end" 
                        onClick={() => {console.log("handleDeleteCategory");
                            handleDeleteCategory(categoryId)}}
                        >
                        </button>
                    ):null
            }
            <div className="category-tag-header">{t("Taso")} {categoryIndex}</div>            
            {
                disableDelete === false? 
                (
                    <div className="category-tag-help">{t("Category help")}</div>
                ):null
            }

            <FormCheck className="category-checkbox" type="checkbox" onClick={forceOrderChanged} label={t("Pakotettu allekirjoitusjärjestys")} />

        <div
            className={"category-tag-item touch-action-none"} 
            ref = {setNodeRef}
            style = {style}
            key = {categoryId}
            {...attributes}
            {...listeners}
        >
            <DndContext
                sensors = {sensors}
                autoScroll = {false}
                collisionDetection={closestCenter}
                onDragEnd = {handleDragEndEmailItem}
            >
            <SortableContext
                items = { signers.map(item => item.email) }
                strategy={rectSortingStrategy}                        
            >             
                {
                signers.map((item, index) => (
                    <EmailItem item = {item} forceOrder = {forceOrder} signIndex = {index+1} handleDelete = {handleDeleteEmail} key={item.email}></EmailItem>
                    ))
                }
            </SortableContext>
            </DndContext> 
          </div>
          <div  className={"category-tag-form"}>
          <FormControl type="email" id="email" name="email" value={email} 
                            onKeyDown={handleKeyDown} 
                            onPaste={handlePaste} 
                            onBlur={handleBlur}
                            placeholder={t("Add E-mail address")} 
                            multiple 
                            onChange={handleChange}/>
          <p className="emailError">{emailError}</p>
          <p>  i.e. john.doe@example.com, jane.doe@example.com,etc...</p>

            {
               disableDates === false?
                    (<div className="row">
                    <div className="col-md-3">
                        <label htmlFor="duedate">{t("Category due date for signature")}</label><br/>
                        <FormControl type="date" id="duedate" name="duedate" defaultValue ={duedateMin} min = {duedateMin} max = {duedateMax} onClick={setDueDateRanges} onChange={changeHandler}/>
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="reminder">{t("Category reminder")}</label><br />
                        <FormControl type="date" id={"categoryReminder"+categoryId} name="categoryReminder" defaultValue ={reminder} min = {todayString()} max={duedate} onChange={changeHandler}/>
                    </div>
                    </div>
                    ):clearDates()
            }

          <Button className={"category-tag-add-button"} disabled = {addCategoryDisabled} onClick={addSignerCategory}>{t("Lisää taso")}</Button>
          </div>
        </div>
    )        
}

export default SignersCategory;